module.exports = __webpack_public_path__ + "img/avatar-man.557cd11f.svg";